import { AGENCY_ZOOM_ORDER_VALUES } from "../search-customers/customerSearchOptions";

export const AGENCY_ZOOM_TASK_ORDER_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_ORDER_VALUES)[number],
  string
> = {
  asc: "agencyZoomSearchTasksSettings.orderAsc",
  desc: "agencyZoomSearchTasksSettings.orderDesc",
};

export const AGENCY_ZOOM_TASK_CATEGORY_VALUES = ["sales", "onboarding"] as const;

export const AGENCY_ZOOM_TASK_CATEGORY_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_TASK_CATEGORY_VALUES)[number],
  string
> = {
  sales: "agencyZoomSearchTasksSettings.categorySales",
  onboarding: "agencyZoomSearchTasksSettings.categoryOnboarding",
};

export const AGENCY_ZOOM_TASK_STATUS_VALUES = ["open", "done"] as const;
// `cancelled` exists on AgencyZoomTaskStatus for responses and in Omega's JSON schema
// enum, but SearchTasks/UpdateTask CheckInput reject it as an input literal.

export const AGENCY_ZOOM_TASK_STATUS_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_TASK_STATUS_VALUES)[number],
  string
> = {
  open: "agencyZoomSearchTasksSettings.statusOpen",
  done: "agencyZoomSearchTasksSettings.statusDone",
};

export const AGENCY_ZOOM_TASK_PERIOD_VALUES = [
  "past-due-rotting",
  "past-due",
  "remainder-week",
  "next-week",
  "today",
] as const;

export const AGENCY_ZOOM_TASK_PERIOD_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_TASK_PERIOD_VALUES)[number],
  string
> = {
  "past-due-rotting": "agencyZoomSearchTasksSettings.periodPastDueRotting",
  "past-due": "agencyZoomSearchTasksSettings.periodPastDue",
  "remainder-week": "agencyZoomSearchTasksSettings.periodRemainderWeek",
  "next-week": "agencyZoomSearchTasksSettings.periodNextWeek",
  today: "agencyZoomSearchTasksSettings.periodToday",
};
